import React, { useEffect } from 'react';
import './Gift.css';
import pixQRCode from '../assets/pix.jpeg';
import academia from '../assets/academia.png';
import barriga from '../assets/barriga.png';
import cartao from '../assets/cartao.png';
import fralda from '../assets/fralda.png';
import luademel from '../assets/luademel.png';
import massagem from '../assets/massagem.png';
import monjauro from '../assets/monjauro.png';
import tpm from '../assets/tpm.png';
import dj from '../assets/dj.png';
import fotonoivo from '../assets/fotonoivo.png';
import pedido from '../assets/pedido.png';
import palpite from '../assets/palpite.png';

// Type declaration for Stripe buy button
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-buy-button': {
        'buy-button-id': string;
        'publishable-key': string;
      };
    }
  }
}

const Gift: React.FC = () => {
  useEffect(() => {
    // Load Stripe script
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/buy-button.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const gifts = [
    {
      image: academia,
      title: 'Academia',
      description: '3 meses de academia pro noivo perder os kg que ganhou na lua de mel',
      value: 'R$350,00'
    },
    {
      image: barriga,
      title: 'Aluguel',
      description: '1 mês de aluguel',
      value: 'R$1.800,00'
    },
    {
      image: cartao,
      title: 'Fatura do Cartão',
      description: 'Ajuda pro noivo pagar a fatura do cartão da noiva',
      value: 'R$400,00'
    },
    {
      image: fralda,
      title: 'Máscara de Gás',
      description: 'Máscara de gás pra trocar fralda do futuro filho',
      value: 'R$250,00'
    },
    {
      image: luademel,
      title: 'Lua de Mel',
      description: 'Ajuda pra pagar a lua de mel dos noivos',
      value: 'R$500,00'
    },
    {
      image: massagem,
      title: 'Massagem Relaxante',
      description: 'Massagem relaxante pro noivo depois de ver a conta da festa de casamento',
      value: 'R$300,00'
    },
    {
      image: monjauro,
      title: 'Monjauro',
      description: 'Monjauro pra noiva perder os kilos que ganhou na lua de mel',
      value: 'R$1.000,00'
    },
    {
      image: tpm,
      title: 'Fundo de Emergência',
      description: 'Fundo de emergência pra comprar chocolate pra noiva de TPM',
      value: 'R$400,00'
    },
    {
      image: dj,
      title: 'DJ Extra',
      description: 'Vaquinha pro cara do som ficar 3 horas extras',
      value: 'R$500,00'
    },
    {
      image: fotonoivo,
      title: 'Foto com o Noivo',
      description: 'Foto com o noivo',
      value: 'R$150,00'
    },
    {
      image: pedido,
      title: 'Pedido de Casamento',
      description: 'Pedir a namorada em casamento na nossa festa',
      value: 'R$1.500,00'
    },
    {
      image: palpite,
      title: 'Dar Palpite',
      description: 'Dar palpite sobre nosso casamento',
      value: 'R$5.000,00'
    }
  ];

  return (
    <div className="gift-section">
      <h1>Presente de Casamento</h1>
      <div className="gift-grid">
        {gifts.map((gift, index) => (
          <div key={index} className="gift-card">
            <div className="gift-image-container">
              <img src={gift.image} alt={gift.title} className="gift-image" />
            </div>
            <div className="gift-info">
              <h3 className="gift-title">{gift.title}</h3>
              <p className="gift-description">{gift.description}</p>
              <div className="gift-value">{gift.value}</div>
            </div>
          </div>
        ))}
      </div>
      <p>Ajude-nos a realizar nosso sonho! Escolha uma das opções abaixo para contribuir com nosso presente de casamento.</p>
      
      <div className="payment-options">
        <div className="payment-option">
          <h3>PIX</h3>
          <p>Escaneie o QR Code abaixo para nos presentear via PIX ou use a chave pix CPF: 009.408.559-50 (Lorhan Andrade Bozza - Nubank)</p>
          <div className="pix-container">
            <img src={pixQRCode} alt="PIX QR Code" className="pix-qr-code" />
          </div>
        </div>

        <div className="payment-option">
          <h3>Cartão de Crédito</h3>
          <p>Clique no botão abaixo para nos presentear com cartão</p>
          <div className="stripe-container">
            <div
              dangerouslySetInnerHTML={{
                __html: `<stripe-buy-button
                  buy-button-id="buy_btn_1Rk2dyAMkiHqrM4DgSvk8rU0"
                  publishable-key="pk_live_51RjSSlAMkiHqrM4DUXL3MBjfeWHsteaa6jnAlj8eNYWTtQZaRZ69FFwXPD1exTsVizvEazFCvRl164Wzm51CPT3H00qXu79WlE"
                ></stripe-buy-button>`
              }}
            />
          </div>
        </div>
      </div>

      <div className="gift-message">
        <p>Obrigado por fazer parte do nosso dia especial! 💕</p>
      </div>
    </div>
  );
};

export default Gift; 